import AsyncApiComponent from './containers/AsyncApi/Standalone';

import { hljs } from './helpers';

export { hljs };
export default AsyncApiComponent;
